import React from 'react'
import Styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={Styles.footerWrapper}>
        <p>© 2025, Greendzine Technologies Pvt. Ltd. All Rights Reserved.</p>
    </div>
  )
}

export default Footer